module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"addCart":"Ajouter au panier"},"en":{"addCart":"Add to basket"},"de":{"addCart":"In den Warenkorb"},"es":{"addCart":"Añadir a la cesta"},"it":{"addCart":"Aggiungi al carrello"},"nl":{"addCart":"Toevoegen aan winkelmand"},"pt":{"addCart":"Adicionar ao carrinho"}}')
  delete Component.options._Ctor
}
